import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";

/**
 * Dialog data
 */
export class DialogAlertData {

  /** Dialog title */
  title: String;

  /** Message to show */
  text: String;

  constructor(title: String, text: String) {
    this.title = title;
    this.text = text;
  }
}

/**
 * Delete dialog template
 *
 * Using with MatDialog:
 *
 ```
 // Open dialog
 const dialogRef = this.dialog.open(DialogAlertComponent, {
     data: new DialogAlertData('Are you sure?', 'If you do this bad things will happen')
 });

 // Callback for when dialog is closed
 const result = dialogRef.afterClosed().toPromise()
 if (result) {
   // Confirmed!
 } else {
   // Refused...
 }
 ```
 */
@Component({
  selector: 'kis-dialog-alert',
  templateUrl: './dialog-alert.component.html',
  styleUrls: ['./dialog-alert.component.scss']
})
export class DialogAlertComponent implements OnInit {

  /**
   * @param dialogRef - to use dialog operations
   * @param data - data to be injected
   */
  constructor(public dialogRef: MatDialogRef<DialogAlertComponent>,
              @Inject(MAT_DIALOG_DATA) public data: DialogAlertData) {}

  ngOnInit(): void {
  }

}
